/**
 * @module Enum
 */
/**
 * @enum {string} PostType
 * @type {{FLIGHT: string, TRANSPORTATION: string, ACCOMMODATION: string, ACTIVITY: string}}
 */
export const PostType = {
    ACTIVITY: 'ACTIVITY',
    ACCOMMODATION: 'ACCOMMODATION',
    FLIGHT: 'FLIGHT',
    TRANSPORTATION: 'TRANSPORTATION'
};
/**
 * @enum {string} CostDistributionType
 * @type {{TOTAL: string, PER_PERSON: string}}
 */
export const CostDistributionType = {
    PER_PERSON: 'PER_PERSON',
    TOTAL: 'TOTAL'
};
/**
 * @enum {string} PermissionType
 * @type {{OWNER: string, EDITOR: string, VIEWER: string, MEMBER: string}}
 */
export var PermissionType;
(function (PermissionType) {
    PermissionType["OWNER"] = "OWNER";
    PermissionType["VIEWER"] = "VIEWER";
    PermissionType["MEMBER"] = "MEMBER";
    PermissionType["EDITOR"] = "EDITOR";
})(PermissionType || (PermissionType = {}));
/**
 * @enum {string} TransportationType
 * @type {{OTHER: string, PUBLIC_TRANSPORTATION: string, RIDE_SHARING: string, RENTAL_CAR: string}}
 */
export const TransportationType = {
    RENTAL_CAR: 'RENTAL_CAR',
    RIDE_SHARING: 'RIDE_SHARING',
    PUBLIC_TRANSPORTATION: 'PUBLIC_TRANSPORTATION',
    OTHER: 'OTHER'
};
/**
 * @enum {string} FriendshipStatusType
 * @type {{ACCEPTED: string, BLOCKED: string, PENDING: string}}
 */
export const FriendshipStatusType = {
    ACCEPTED: 'ACCEPTED',
    PENDING: 'PENDING',
    BLOCKED: 'BLOCKED'
};
/**
 * @enum {string} AccommodationType
 * @type {{OTHER: string, AIRBNB: string, HOTEL: string}}
 */
export const AccommodationType = {
    HOTEL: 'HOTEL',
    AIRBNB: 'AIRBNB',
    OTHER: 'OTHER'
};
/**
 * @enum {string} NotificationType
 * @type {{TRIP_MEMBER_PERMISSION_CHANGE: string, FRIENDSHIP_ADD: string, TRIP_MEMBER_ADD: string, POST_LIKE: string, TRIP_MEMBER_REMOVE: string, TRIP_POST_REMOVE: string, COMMENT_DELETE: string, POST_UNLIKE: string, FRIENDSHIP_REMOVE: string, POST_PARTICIPANT_REMOVE: string, TRIP_POST_NEW: string, COMMENT_UNLIKE: string, POST_PARTICIPANT_ADD: string, FRIENDSHIP_BLOCK: string, POST_COMMENT: string, COMMENT_REPLY: string, COMMENT_LIKE: string, POST_UPDATE: string}}
 */
export const NotificationType = {
    FRIENDSHIP_ADD: 'FRIENDSHIP_ADD',
    FRIENDSHIP_BLOCK: 'FRIENDSHIP_BLOCK',
    FRIENDSHIP_REMOVE: 'FRIENDSHIP_REMOVE',
    TRIP_MEMBER_ADD: 'TRIP_MEMBER_ADD',
    TRIP_MEMBER_REMOVE: 'TRIP_MEMBER_REMOVE',
    TRIP_MEMBER_PERMISSION_CHANGE: 'TRIP_MEMBER_PERMISSION_CHANGE',
    TRIP_POST_NEW: 'TRIP_POST_NEW',
    TRIP_POST_REMOVE: 'TRIP_POST_REMOVE',
    POST_LIKE: 'POST_LIKE',
    POST_UNLIKE: 'POST_UNLIKE',
    POST_COMMENT: 'POST_COMMENT',
    POST_PARTICIPANT_ADD: 'POST_PARTICIPANT_ADD',
    POST_PARTICIPANT_REMOVE: 'POST_PARTICIPANT_REMOVE',
    POST_UPDATE: 'POST_UPDATE',
    COMMENT_REPLY: 'COMMENT_REPLY',
    COMMENT_LIKE: 'COMMENT_LIKE',
    COMMENT_UNLIKE: 'COMMENT_UNLIKE',
    COMMENT_DELETE: 'COMMENT_DELETE'
};
/**
 * @enum {string} NotificationStatusType
 * @type {{VIEWED: string, PASSIVE: string, ACTIVE: string, HIDDEN: string}}
 */
export const NotificationStatusType = {
    ACTIVE: 'ACTIVE',
    VIEWED: 'VIEWED',
    HIDDEN: 'HIDDEN',
    PASSIVE: 'PASSIVE'
};
/**
 * @enum {string} TripInvitationStatus
 * @type {{ACCEPTED: string, REJECTED: string, PENDING: string}}
 */
export const TripInvitationStatus = {
    ACCEPTED: 'ACCEPTED',
    REJECTED: 'REJECTED',
    PENDING: 'PENDING'
};
